import { render, staticRenderFns } from "./OverlapLayer.vue?vue&type=template&id=de79dfc0&scoped=true&lang=pug"
import script from "./OverlapLayer.vue?vue&type=script&lang=js"
export * from "./OverlapLayer.vue?vue&type=script&lang=js"
import style0 from "./OverlapLayer.vue?vue&type=style&index=0&id=de79dfc0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de79dfc0",
  null
  
)

export default component.exports